import React, { useEffect } from 'react';
import PageWithTitleLayout from '../Layout/PageWithTitleLayout';
import { 
    Tab,
    Box
} from '@mui/material'
import {
    TabContext,
    TabList,
} from '@mui/lab'
import UserManagementList from './UserManagementList';
import UserManagementEdit from './UserManagementEdit'
import UserManagementStores from './UserManagementStores';
import EditStore from './EditStore';
import { useStickyString } from '../../Utilities/useStickyState';
import { PATHS } from '../../constants';
import { Route, Switch } from 'react-router-dom';

const ManagerSettings = ({ history }) => {
    const [tabValue, setTabValue] = useStickyString('users', 'frederickManagerSettingsTabValue')
    useEffect(() => {
        if(history.location.pathname.includes('stores')) {
            setTabValue('stores')
        } else {
            setTabValue('users')
        }
    }, [history.location.pathname, setTabValue])
    
    return (
        <PageWithTitleLayout title='ユーザー・店舗情報'>
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList 
                        onChange={(e, newValue) => { 
                            history.push(PATHS.managerSettings + newValue); setTabValue(newValue)}
                        }
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="ユーザー情報" value="users" />
                        <Tab label="店舗情報" value="stores" />
                    </TabList>
                </Box>
                <Switch>
                    <Route exact path={PATHS.managerSettingsUsers} component={UserManagementList} />
                    <Route exact path={PATHS.managerSettingsStores} component={UserManagementStores} />
                    <Route exact path={PATHS.managerSettingsUser} component={UserManagementEdit} />
                    <Route exact path={PATHS.managerSettingsStore} component={EditStore} />
                </Switch>
            </TabContext>
        </PageWithTitleLayout>
    );
}

export default ManagerSettings;